module.exports = __webpack_public_path__ + "static/media/cocktail_bus_budapest.80b713a2.png";